import { render, staticRenderFns } from "./WaGroup.vue?vue&type=template&id=276aa902&scoped=true"
import script from "./WaGroup.vue?vue&type=script&lang=js"
export * from "./WaGroup.vue?vue&type=script&lang=js"
import style0 from "./WaGroup.vue?vue&type=style&index=0&id=276aa902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276aa902",
  null
  
)

export default component.exports